// // CourseContentPage.jsx page
// import { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';

// import { getCourseFullStructure } from '../../api/CoursesApi';
// import {
//     getCourseLessonProgress,
//     updateBulkLessonProgress,
//     getCourseProgressSummary,
//     trackLessonProgress,
//     getLastPlayedLesson,
// } from '../../api/LessonProgressApi';

// import CourseHeader from './components/CourseHeader';
// import CourseLayout from './components/CourseLayout';
// import ErrorState from './components/ErrorState';
// import Footer from '../../components/common/Footer';
// import LoadingState from '../../components/common/LoadingState';
// import "../../static/CourseContentPage.css";

// const CourseContentPage = () => {
//     const { id } = useParams();
//     const navigate = useNavigate();
//     const [course, setCourse] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState('');
//     const [activeVideo, setActiveVideo] = useState(null);
//     const [activeLessonId, setActiveLessonId] = useState(null);
//     const [expandedSections, setExpandedSections] = useState(new Set());
//     const [completionStatus, setCompletionStatus] = useState({});
//     const [progressSummary, setProgressSummary] = useState(null);
//     const [lastPlayed, setLastPlayed] = useState(null);

//     const markLessonAsCompleted = async (lesson) => {
//         try {
//             let lessonId;
//             if (typeof lesson === 'object' && lesson !== null) {
//                 lessonId = lesson.id;
//             } else {
//                 lessonId = lesson;
//             }

//             if (!lessonId || isNaN(Number(lessonId))) {
//                 return;
//             }

//             const numericLessonId = Number(lessonId);

//             if (completionStatus[numericLessonId]) {
//                 return;
//             }

//             setCompletionStatus(prev => ({
//                 ...prev,
//                 [numericLessonId]: true
//             }));

//             const videoDuration = activeVideo?.video_duration || lesson?.video_duration || 0;

//             await trackLessonPlay(numericLessonId, {
//                 current_time: Math.floor(videoDuration),
//                 completed: true,
//                 total_duration: videoDuration
//             });

//             const bulkProgressData = [
//                 {
//                     lesson_id: numericLessonId,
//                     completed: true,
//                     watched_duration: Math.floor(videoDuration)
//                 }
//             ];

//             await updateBulkLessonProgress(id, bulkProgressData);

//             const summaryResponse = await getCourseProgressSummary(id);
//             setProgressSummary(summaryResponse.data);

//         } catch (error) {
//             const lessonId = typeof lesson === 'object' ? lesson.id : lesson;
//             setCompletionStatus(prev => {
//                 const newState = { ...prev };
//                 delete newState[lessonId];
//                 return newState;
//             });
//         }
//     };

//     const trackLessonPlay = async (lessonId, data) => {
//         try {
//             if (!lessonId || isNaN(Number(lessonId))) {
//                 return;
//             }

//             const numericLessonId = Number(lessonId);

//             await trackLessonProgress(numericLessonId, {
//                 current_time: data.current_time || 0,
//                 completed: data.completed || false,
//                 total_duration: data.total_duration || 0
//             });

//         } catch (error) {
//             throw error;
//         }
//     };

//     useEffect(() => {
//         const fetchCourseContent = async () => {
//             try {
//                 const [courseResponse, progressResponse, summaryResponse, lastPlayedResponse] = await Promise.all([
//                     getCourseFullStructure(id),
//                     getCourseLessonProgress(id),
//                     getCourseProgressSummary(id),
//                     getLastPlayedLesson(id).catch(() => ({ data: null }))
//                 ]);

//                 setCourse(courseResponse.data);
//                 setProgressSummary(summaryResponse.data);

//                 const progressData = progressResponse.data;
//                 const completedLessons = {};

//                 if (Array.isArray(progressData)) {
//                     progressData.forEach(progress => {
//                         const lessonId = progress.lesson || progress.lesson_id || progress.id;

//                         if (progress.completed && lessonId) {
//                             completedLessons[lessonId] = true;
//                         }
//                     });
//                 }

//                 setCompletionStatus(completedLessons);

//                 if (lastPlayedResponse.data && lastPlayedResponse.data.lesson_id) {
//                     setLastPlayed(lastPlayedResponse.data);
//                 }

//                 let activeVideoToSet = null;
//                 if (lastPlayedResponse.data && lastPlayedResponse.data.lesson_id) {
//                     activeVideoToSet = findLessonInCourse(courseResponse.data, lastPlayedResponse.data.lesson_id);
//                     if (activeVideoToSet) {
//                         activeVideoToSet.lastPlayedTime = lastPlayedResponse.data.current_time;
//                         setActiveLessonId(lastPlayedResponse.data.lesson_id);
//                     }
//                 }

//                 if (!activeVideoToSet) {
//                     activeVideoToSet = findFirstVideo(courseResponse.data);
//                     if (activeVideoToSet) {
//                         setActiveLessonId(activeVideoToSet.id);
//                     }
//                 }

//                 setActiveVideo(activeVideoToSet);

//                 if (courseResponse.data.sections && courseResponse.data.sections.length > 0) {
//                     setExpandedSections(new Set([courseResponse.data.sections[0].id]));
//                 }

//             } catch (err) {
//                 if (err.response?.status === 404) {
//                     setError('Course not found. Please check the course ID.');
//                 } else if (err.response?.status === 500) {
//                     setError('Server error. Please try again later.');
//                 } else {
//                     setError('Failed to load course content');
//                 }
//             } finally {
//                 setLoading(false);
//             }
//         };

//         if (id) {
//             if (!id || id === '-pdO6JrlDkw') {
//                 setError('Invalid course ID');
//                 setLoading(false);
//                 return;
//             }
//             fetchCourseContent();
//         }
//     }, [id]);

//     const findFirstVideo = (courseData) => {
//         if (!courseData.sections) return null;

//         for (const section of courseData.sections) {
//             for (const subsection of section.subsections) {
//                 if (subsection.lessons && subsection.lessons.length > 0) {
//                     const firstLesson = subsection.lessons[0];
//                     return {
//                         ...firstLesson,
//                         sectionTitle: section.title,
//                         subsectionTitle: subsection.title,
//                         lastPlayedTime: 0
//                     };
//                 }
//             }
//         }
//         return null;
//     };

//     const findLessonInCourse = (courseData, lessonId) => {
//         if (!courseData.sections) return null;

//         for (const section of courseData.sections) {
//             for (const subsection of section.subsections) {
//                 if (subsection.lessons) {
//                     const lesson = subsection.lessons.find(l => l.id === lessonId);
//                     if (lesson) {
//                         return {
//                             ...lesson,
//                             sectionTitle: section.title,
//                             subsectionTitle: subsection.title,
//                             lastPlayedTime: 0
//                         };
//                     }
//                 }
//             }
//         }
//         return null;
//     };

//     const toggleSection = (sectionId) => {
//         const newExpanded = new Set(expandedSections);
//         if (newExpanded.has(sectionId)) {
//             newExpanded.delete(sectionId);
//         } else {
//             newExpanded.add(sectionId);
//         }
//         setExpandedSections(newExpanded);
//     };

//     const handleVideoSelect = async (lesson, sectionTitle, subsectionTitle) => {
//         const videoData = {
//             ...lesson,
//             sectionTitle,
//             subsectionTitle,
//             lastPlayedTime: lastPlayed?.lesson_id === lesson.id ? lastPlayed.current_time : 0
//         };
//         setActiveVideo(videoData);
//         setActiveLessonId(lesson.id);
//     };

//     if (loading) {
//         return (
//             <LoadingState
//                 variant="page"
//                 message="Loading course content..."
//             />
//         );
//     }

//     if (error || !course) {
//         return <ErrorState error={error} navigate={navigate} />;
//     }

//     return (
//         <div className="content-page">
//             <div className="content">
//                 <CourseHeader
//                     course={course}
//                     progressSummary={progressSummary}
//                     lastPlayed={lastPlayed}
//                     activeVideo={activeVideo}
//                     completionStatus={completionStatus}
//                     onResumeLastPlayed={handleVideoSelect}
//                     findLessonInCourse={findLessonInCourse}
//                 />

//                 <CourseLayout
//                     course={course}
//                     activeVideo={activeVideo}
//                     activeLessonId={activeLessonId}
//                     expandedSections={expandedSections}
//                     completionStatus={completionStatus}
//                     progressSummary={progressSummary}
//                     onVideoSelect={handleVideoSelect}
//                     onToggleSection={toggleSection}
//                     onMarkComplete={markLessonAsCompleted}
//                 />
//             </div>

//             <Footer />
//         </div>
//     );
// };

// export default CourseContentPage;

// CourseContentPage.jsx page
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { getCourseFullStructure } from '../../api/CoursesApi';
import {
    getCourseLessonProgress,
    updateBulkLessonProgress,
    getCourseProgressSummary,
    trackLessonProgress,
    getLastPlayedLesson,
} from '../../api/LessonProgressApi';

import CourseHeader from './components/CourseHeader';
import CourseLayout from './components/CourseLayout';
import ErrorState from './components/ErrorState';
import Footer from '../../components/common/Footer';
import LoadingState from '../../components/common/LoadingState';
import "../../static/CourseContentPage.css";

const CourseContentPage = () => {
    const { slug } = useParams();                    // <-- was { id }
    const navigate = useNavigate();
    const [course, setCourse] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [activeVideo, setActiveVideo] = useState(null);
    const [activeLessonId, setActiveLessonId] = useState(null);
    const [expandedSections, setExpandedSections] = useState(new Set());
    const [completionStatus, setCompletionStatus] = useState({});
    const [progressSummary, setProgressSummary] = useState(null);
    const [lastPlayed, setLastPlayed] = useState(null);

    const markLessonAsCompleted = async (lesson) => {
        try {
            let lessonId;
            if (typeof lesson === 'object' && lesson !== null) {
                lessonId = lesson.id;
            } else {
                lessonId = lesson;
            }

            if (!lessonId || isNaN(Number(lessonId))) {
                return;
            }

            const numericLessonId = Number(lessonId);

            if (completionStatus[numericLessonId]) {
                return;
            }

            setCompletionStatus(prev => ({
                ...prev,
                [numericLessonId]: true
            }));

            const videoDuration = activeVideo?.video_duration || lesson?.video_duration || 0;

            await trackLessonPlay(numericLessonId, {
                current_time: Math.floor(videoDuration),
                completed: true,
                total_duration: videoDuration
            });

            const bulkProgressData = [
                {
                    lesson_id: numericLessonId,
                    completed: true,
                    watched_duration: Math.floor(videoDuration)
                }
            ];

            await updateBulkLessonProgress(slug, bulkProgressData);   // <-- was id

            const summaryResponse = await getCourseProgressSummary(slug);   // <-- was id
            setProgressSummary(summaryResponse.data);

        } catch (error) {
            const lessonId = typeof lesson === 'object' ? lesson.id : lesson;
            setCompletionStatus(prev => {
                const newState = { ...prev };
                delete newState[lessonId];
                return newState;
            });
        }
    };

    const trackLessonPlay = async (lessonId, data) => {
        try {
            if (!lessonId || isNaN(Number(lessonId))) {
                return;
            }

            const numericLessonId = Number(lessonId);

            await trackLessonProgress(numericLessonId, {
                current_time: data.current_time || 0,
                completed: data.completed || false,
                total_duration: data.total_duration || 0
            });

        } catch (error) {
            throw error;
        }
    };

    useEffect(() => {
        const fetchCourseContent = async () => {
            try {
                const [courseResponse, progressResponse, summaryResponse, lastPlayedResponse] = await Promise.all([
                    getCourseFullStructure(slug),                    // <-- was id
                    getCourseLessonProgress(slug),                   // <-- was id
                    getCourseProgressSummary(slug),                  // <-- was id
                    getLastPlayedLesson(slug).catch(() => ({ data: null }))   // <-- was id
                ]);

                setCourse(courseResponse.data);
                setProgressSummary(summaryResponse.data);

                const progressData = progressResponse.data;
                const completedLessons = {};

                if (Array.isArray(progressData)) {
                    progressData.forEach(progress => {
                        const lessonId = progress.lesson || progress.lesson_id || progress.id;

                        if (progress.completed && lessonId) {
                            completedLessons[lessonId] = true;
                        }
                    });
                }

                setCompletionStatus(completedLessons);

                if (lastPlayedResponse.data && lastPlayedResponse.data.lesson_id) {
                    setLastPlayed(lastPlayedResponse.data);
                }

                let activeVideoToSet = null;
                if (lastPlayedResponse.data && lastPlayedResponse.data.lesson_id) {
                    activeVideoToSet = findLessonInCourse(courseResponse.data, lastPlayedResponse.data.lesson_id);
                    if (activeVideoToSet) {
                        activeVideoToSet.lastPlayedTime = lastPlayedResponse.data.current_time;
                        setActiveLessonId(lastPlayedResponse.data.lesson_id);
                    }
                }

                if (!activeVideoToSet) {
                    activeVideoToSet = findFirstVideo(courseResponse.data);
                    if (activeVideoToSet) {
                        setActiveLessonId(activeVideoToSet.id);
                    }
                }

                setActiveVideo(activeVideoToSet);

                if (courseResponse.data.sections && courseResponse.data.sections.length > 0) {
                    setExpandedSections(new Set([courseResponse.data.sections[0].id]));
                }

            } catch (err) {
                if (err.response?.status === 404) {
                    setError('Course not found. Please check the course link.');
                } else if (err.response?.status === 500) {
                    setError('Server error. Please try again later.');
                } else {
                    setError('Failed to load course content');
                }
            } finally {
                setLoading(false);
            }
        };

        if (slug) {                                     // <-- was id
            if (slug === '-pdO6JrlDkw') {               // <-- was id (kept the guard just in case)
                setError('Invalid course');
                setLoading(false);
                return;
            }
            fetchCourseContent();
        }
    }, [slug]);                                         // <-- was id

    const findFirstVideo = (courseData) => {
        if (!courseData.sections) return null;

        for (const section of courseData.sections) {
            for (const subsection of section.subsections) {
                if (subsection.lessons && subsection.lessons.length > 0) {
                    const firstLesson = subsection.lessons[0];
                    return {
                        ...firstLesson,
                        sectionTitle: section.title,
                        subsectionTitle: subsection.title,
                        lastPlayedTime: 0
                    };
                }
            }
        }
        return null;
    };

    const findLessonInCourse = (courseData, lessonId) => {
        if (!courseData.sections) return null;

        for (const section of courseData.sections) {
            for (const subsection of section.subsections) {
                if (subsection.lessons) {
                    const lesson = subsection.lessons.find(l => l.id === lessonId);
                    if (lesson) {
                        return {
                            ...lesson,
                            sectionTitle: section.title,
                            subsectionTitle: subsection.title,
                            lastPlayedTime: 0
                        };
                    }
                }
            }
        }
        return null;
    };

    const toggleSection = (sectionId) => {
        const newExpanded = new Set(expandedSections);
        if (newExpanded.has(sectionId)) {
            newExpanded.delete(sectionId);
        } else {
            newExpanded.add(sectionId);
        }
        setExpandedSections(newExpanded);
    };

    const handleVideoSelect = async (lesson, sectionTitle, subsectionTitle) => {
        const videoData = {
            ...lesson,
            sectionTitle,
            subsectionTitle,
            lastPlayedTime: lastPlayed?.lesson_id === lesson.id ? lastPlayed.current_time : 0
        };
        setActiveVideo(videoData);
        setActiveLessonId(lesson.id);
    };

    if (loading) {
        return (
            <LoadingState
                variant="page"
                message="Loading course content..."
            />
        );
    }

    if (error || !course) {
        return <ErrorState error={error} navigate={navigate} />;
    }

    return (
        <div className="content-page">
            <div className="content">
                <CourseHeader
                    course={course}
                    progressSummary={progressSummary}
                    lastPlayed={lastPlayed}
                    activeVideo={activeVideo}
                    completionStatus={completionStatus}
                    onResumeLastPlayed={handleVideoSelect}
                    findLessonInCourse={findLessonInCourse}
                />

                <CourseLayout
                    course={course}
                    activeVideo={activeVideo}
                    activeLessonId={activeLessonId}
                    expandedSections={expandedSections}
                    completionStatus={completionStatus}
                    progressSummary={progressSummary}
                    onVideoSelect={handleVideoSelect}
                    onToggleSection={toggleSection}
                    onMarkComplete={markLessonAsCompleted}
                />
            </div>

            <Footer />
        </div>
    );
};

export default CourseContentPage;